import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import vendorServices from '../vendorServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';


function VendorForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const initialValues = {
        vendorName:"",
        city:"",
        state:"",
        address:"",
        zip:"",
        phone:"",
        email:"",
        productCategory:"",
        vendorCategory:"",
        gst:"",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            vendorName:data.vendorName,
            city:data.city,
            state:data.state,
            address:data.address,
            zip:data.zip,
            phone:data.phone,
            email:data.email,
            productCategory:data.productCategory,
            vendorCategory:data.vendorCategory,
            gst:data.gst
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        vendorName:Yup.string().required("Required"),
        city:Yup.string().required("Required"),
        phone:Yup.string().matches(/^[0-9]+$/, "Phone number must contain only digits").length(10, "Phone number must be exactly 10 digits").required("Required"),
        productCategory:Yup.string().required("Required"),
        vendorCategory:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const onSubmit = (values, onSubmitProps) => {
        vendorServices.save(values).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            callBack();
        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Vendor</button>
                </Tooltip>
            }
            {data &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="md"
                aria-describedby="alert-dialog-slide-description"
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Add New"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Vendor Name" name="vendorName" 
                                                        
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="GST" name="gst"   
                                                    />
                                                </div>

                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Phone" name="phone" 
                                                        
                                                    />
                                                </div>
                                                <div className="col-md-6 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Email" name="email"   
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="City" name="city"   
                                                    />
                                                </div>

                                                <div className='col-md-4 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="State" name="state"  
                                                        options={masters['indian-state']} multiple={false} 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text"
                                                        label="Pincode" name="zip"   
                                                    />
                                                </div>

                                                <div className="col-md-12 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" multiline={true}
                                                        label="Address" name="address"   
                                                    />
                                                </div>

                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Vendor Category" name="vendorCategory"  
                                                        options={masters['vendor-category']} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Product Category" name="productCategory"  
                                                        options={masters['product-category']} multiple={false} 
                                                    />
                                                </div>
                                            </div>
                                           
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit">Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                { JSON.stringify(formik.values)  }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default VendorForm